export default {
    message: {
        "Ricerca_prodotti": "Produktsuche",
        "Catalogo": "Katalog",
        "Area": "Bereich",
        "Categorie": "Kategorien",
        "Marchi": "Marken",
        "Stagione": "Saison",
        "Prezzo": "Preis",
        "Genere": "Geschlecht",
        "Pagina": "Seite",
        "di": "von",
        "Cerca": "Suchen",
        "vedi": "gezeigt",
        "totali": "gesamt",
        "Nessun prodotto trovato": "Keine Produkte gefunden",
        "Caricamento prodotti in corso": "Laden von Produkten",
        "Aggiungi al carrello": "In den Warenkorb legen",
        "Loading": "Wird geladen ...",
    },
}
